import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../routes/Routes';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <h1 style={{ fontSize: '4em' }}>Oops Page Not Found!</h1>
      <span style={{ cursor: 'pointer' }} onClick={() => navigate(ROUTE_PATHS.DASHBOARD)}>
        Homepage
      </span>
    </div>
  );
};

export default NotFoundPage;
